import { getCurrentScope as g, onScopeDispose as v, shallowRef as h, watchEffect as b, readonly as m, unref as T, ref as y } from "vue";
function C(e, n) {
  var o;
  const t = h();
  return b(() => {
    t.value = e();
  }, {
    ...n,
    flush: (o = void 0) != null ? o : "sync"
  }), m(t);
}
function P(e) {
  return g() ? (v(e), !0) : !1;
}
function f(e) {
  return typeof e == "function" ? e() : T(e);
}
const p = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const D = (e) => e != null, S = Object.prototype.toString, F = (e) => S.call(e) === "[object Object]", d = () => {
}, W = /* @__PURE__ */ O();
function O() {
  var e, n;
  return p && ((e = window?.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((n = window?.navigator) == null ? void 0 : n.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function j(e, n) {
  function o(...t) {
    return new Promise((r, i) => {
      Promise.resolve(e(() => n.apply(this, t), { fn: n, thisArg: this, args: t })).then(r).catch(i);
    });
  }
  return o;
}
function x(e, n = {}) {
  let o, t, r = d;
  const i = (u) => {
    clearTimeout(u), r(), r = d;
  };
  return (u) => {
    const c = f(e), l = f(n.maxWait);
    return o && i(o), c <= 0 || l !== void 0 && l <= 0 ? (t && (i(t), t = null), Promise.resolve(u())) : new Promise((s, w) => {
      r = n.rejectOnCancel ? w : s, l && !t && (t = setTimeout(() => {
        o && i(o), t = null, s(u());
      }, l)), o = setTimeout(() => {
        t && i(t), t = null, s(u());
      }, c);
    });
  };
}
function _(e, n = 200, o = {}) {
  return j(
    x(n, o),
    e
  );
}
function I(e, n, o = {}) {
  const {
    immediate: t = !0
  } = o, r = y(!1);
  let i = null;
  function a() {
    i && (clearTimeout(i), i = null);
  }
  function u() {
    r.value = !1, a();
  }
  function c(...l) {
    a(), r.value = !0, i = setTimeout(() => {
      r.value = !1, i = null, e(...l);
    }, f(n));
  }
  return t && (r.value = !0, p && c()), P(u), {
    isPending: m(r),
    start: c,
    stop: u
  };
}
export {
  C as computedEager,
  j as createFilterWrapper,
  x as debounceFilter,
  C as eagerComputed,
  p as isClient,
  W as isIOS,
  F as isObject,
  d as noop,
  D as notNullish,
  f as toValue,
  P as tryOnScopeDispose,
  _ as useDebounceFn,
  I as useTimeoutFn
};
